import type { EmployeeResponse } from '@nebalkon-workspace/admin-api';

/** FIO for chest badge printing — never falls back to phone. */
export function formatEmployeeBadgeName(employee: EmployeeResponse): string {
  const ind = employee.individual;
  return [ind.last_name, ind.first_name, ind.patronymic]
    .filter(Boolean)
    .join(' ')
    .trim();
}
